import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const InfoSection = styled(Flex)`
  gap: 1px;
  margin-left: 10px;
  flex-direction: column;
  min-width: 300px;
  max-width: 400px;
`
export const CompanyName = styled.div`
  font-size: 0.935rem;
  color: ${COLORS.GREY_T_20};
  font-weight: 700;
`
export const DomainName = styled.div`
  font-size: 0.75rem;
  color: ${COLORS.GREY_T_60};
  font-weight: 500;
`
